import {
  AccessTime,
  ArrowForwardIos,
  ContentCopy,
  Delete,
  Image,
  LibraryBooks,
  Message,
  MicNone,
  Videocam,
} from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Typography } from "@mui/material";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        border: '1px solid #e5e7eb',
        minWidth: '280px',
        maxWidth: '320px',
        position: 'relative'
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: "#3b82f6",
          width: "12px",
          height: "12px",
          top: "50%",
          left: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />

      {/* Botões de ação */}
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 12,
          top: 12,
          cursor: "pointer",
          gap: 8
        }}
      >
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#3b82f6' } }}
        />

        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#ef4444' } }}
        />
      </div>

      {/* Header com ícone e título */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '12px'
      }}>
        <LibraryBooks
          sx={{
            width: "18px",
            height: "18px",
            color: "#ef4444"
          }}
        />
        <div style={{
          color: "#111827",
          fontSize: "14px",
          fontWeight: 600
        }}>
          Conteúdo
        </div>
      </div>

      {/* Lista de elementos */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {data.seq.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "#f9fafb",
              padding: "8px",
              borderRadius: "6px",
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            {item.includes("message") && (
              <>
                <Message sx={{ color: "#ef4444", width: "16px", height: "16px" }} />
                <Typography
                  sx={{
                    textOverflow: "ellipsis",
                    fontSize: "11px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    color: "#6b7280"
                  }}
                >
                  {data.elements.filter(itemLoc => itemLoc.number === item)[0]?.value}
                </Typography>
              </>
            )}
            {item.includes("interval") && (
              <>
                <AccessTime sx={{ color: "#ef4444", width: "16px", height: "16px" }} />
                <Typography
                  sx={{
                    fontSize: "11px",
                    color: "#6b7280"
                  }}
                >
                  {data.elements.filter(itemLoc => itemLoc.number === item)[0]?.value} segundos
                </Typography>
              </>
            )}
            {item.includes("img") && (
              <>
                <Image sx={{ color: "#ef4444", width: "16px", height: "16px" }} />
                <Typography
                  sx={{
                    textOverflow: "ellipsis",
                    fontSize: "11px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    color: "#6b7280"
                  }}
                >
                  {data.elements.filter(itemLoc => itemLoc.number === item)[0]?.original}
                </Typography>
              </>
            )}
            {item.includes("audio") && (
              <>
                <MicNone sx={{ color: "#ef4444", width: "16px", height: "16px" }} />
                <Typography
                  sx={{
                    textOverflow: "ellipsis",
                    fontSize: "11px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    color: "#6b7280"
                  }}
                >
                  {data.elements.filter(itemLoc => itemLoc.number === item)[0]?.original}
                </Typography>
              </>
            )}
            {item.includes("video") && (
              <>
                <Videocam sx={{ color: "#ef4444", width: "16px", height: "16px" }} />
                <Typography
                  sx={{
                    textOverflow: "ellipsis",
                    fontSize: "11px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    color: "#6b7280"
                  }}
                >
                  {data.elements.filter(itemLoc => itemLoc.number === item)[0]?.original}
                </Typography>
              </>
            )}
            {item.includes("document") && (
              <>
                <LibraryBooks sx={{ color: "#ef4444", width: "16px", height: "16px" }} />
                <Typography
                  sx={{
                    textOverflow: "ellipsis",
                    fontSize: "11px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    color: "#6b7280"
                  }}
                >
                  {data.elements.filter(itemLoc => itemLoc.number === item)[0]?.original}
                </Typography>
              </>
            )}
          </div>
        ))}
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#3b82f6",
          width: "12px",
          height: "12px",
          top: "90%",
          right: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
